/* eslint-disable no-lone-blocks */
import React from "react";
import "../../../components/styles/style.css";
import Form from "react-bootstrap/Form";
import { makeStyles } from "@material-ui/core/styles";
import Header from "../../../components/header";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { useDispatch } from "react-redux";
import { userSignIn } from "../../../redux/actions/authActions";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import { spacing } from "@material-ui/system";
import { Alert as MuiAlert } from "@material-ui/lab";
import Footer from "../../../components/footer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import * as ProfessionalsServices from "../../../services/api/ProfessionalsServices";
import Swal from "sweetalert2";

const Alert = styled(MuiAlert)(spacing);

const useStyles = makeStyles((theme) => ({
  root: {},
  page: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "70vh",
    padding: theme.spacing(6, 2),
    "@media (max-width: 600px)": {
      padding: theme.spacing(4, 1.5),
    },
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: 440,
    backgroundColor: "#fff",
    borderRadius: 16,
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(5, 5),
    "@media (max-width: 600px)": {
      padding: theme.spacing(4, 3),
    },
  },
  submit: {
    marginTop: theme.spacing(4),
    borderRadius: "30px",
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: "Roboto",
    backgroundColor: "#54B5CF",
    padding: "10px 20px",
    color: "#F8F8FA",
    width: "100%",
    "&:hover": {
      backgroundColor: "#0facc4",
      textDecoration: "none",
      color: "#fff",
    },
  },
  titulo: {
    color: "#54B5CF",
    fontFamily: "Montserrat",
    fontSize: "26px",
    fontWeight: 800,
    marginBottom: 24,
    textAlign: "center",
    "@media (max-width: 600px)": {
      fontSize: "22px",
    },
  },
  textLink: {
    fontFamily: "Roboto",
    fontWeight: 600,
    fontSize: "15px",
    color: "#54B5CF",
    cursor: "pointer",
    "&:hover": {
      color: "#0facc4",
      textDecoration: "underline",
    },
  },
  linksRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 14,
    marginTop: 22,
  },
  label: {
    fontSize: 13,
    color: "#54B5CF",
    fontFamily: "Roboto",
    fontWeight: 600,
    marginTop: 14,
    marginBottom: 2,
  },
}));

export default function Login() {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  /*   setTimeout(async() => { */
  if (localStorage.getItem("auth")) {
    history.push("/admin/profissional/perfil");
  }
  /*   }, 500); */
  return (
    <div style={{ backgroundColor: "#F8F8FA" }}>
      <Header />
      <CssBaseline />
      <div className={classes.page}>
        <div className={classes.paper}>
            <Typography className={classes.titulo}>
              ÁREA DO PROFISSIONAL
            </Typography>

            <Formik
              initialValues={{
                email: "",
                password: "",
                submit: false,
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .email("Preencha um email válido")
                  .max(255)
                  .required("Preencha um email válido"),
                password: Yup.string()
                  .max(255)
                  .required("Preencha uma senha válida"),
              })}
              onSubmit={async (
                values,
                { setErrors, setStatus, setSubmitting }
              ) => {
                try {
                  await dispatch(
                    userSignIn({
                      email: values?.email,
                      password: values.password,
                    })
                  );

                  window.location.reload();
                } catch (error) {
                  const status = error?.response?.status;
                  const message =
                    status === 401
                      ? "Falha no login. Verifique seu e-mail e senha."
                      : "Não foi possível entrar. Tente novamente.";

                  setStatus({ success: false });
                  setErrors({ submit: message });
                  setSubmitting(false);
                }
              }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                isSubmitting,
                touched,
                values,
              }) => (
                <Form noValidate={true} onSubmit={handleSubmit}>
                  {errors.submit && (
                    <Alert mt={2} mb={1} severity="warning">
                      {errors.submit}
                    </Alert>
                  )}
                  <div className={classes.label}>E-MAIL</div>

                  <TextField
                    type="email"
                    name="email"
                    value={values?.email || ""}
                    error={Boolean(touched?.email && errors?.email)}
                    helperText={touched?.email && errors?.email}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    fullWidth
                    inputProps={{
                      autoComplete: 'off'
                    }}  
                  />

                  <div className={classes.label}>SENHA</div>

                  <TextField
                    type="password"
                    name="password"
                    value={values.password || ""}
                    error={Boolean(touched.password && errors.password)}
                    helperText={touched.password && errors.password}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    fullWidth
                    inputProps={{
                      autocomplete: 'new-password',
                      form: {
                        autocomplete: 'off',
                      },
                    }}
                  />
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className={classes.submit}
                  >
                    Entrar
                  </Button>
                </Form>
              )}
            </Formik>

            <Dialog open={open} onClose={handleClose} hideBackdrop={true}>
              <DialogTitle>Recuperação de senha</DialogTitle>
              <Formik
                initialValues={{
                  emailRecovery: "",
                  submit: false,
                }}
                validationSchema={Yup.object().shape({
                  emailRecovery: Yup.string()
                    .email("Preencha um email válido")
                    .max(255)
                    .required("Preencha um email válido"),
                })}
                onSubmit={async (
                  values,
                  { setErrors, setStatus, setSubmitting }
                ) => {
                  try {
                    {
                      const professionalSpec =
                        await ProfessionalsServices.getByMail(
                          values.emailRecovery
                        );
                      let obs = {
                        email: [professionalSpec?.data[0]?.email],
                        subject: "Recuperação de senha",
                        body: `Olá!<br><br>Para criar sua nova senha, clique no botão abaixo:<br> https://minhafono.com.br/recupera/registro/${professionalSpec.data[0].id}/${professionalSpec.data[0].version}<br>Se você não fez essa solicitação, não se preocupe, sua senha não será alterada.`,
                      };

                      await ProfessionalsServices.sendMail(obs).then((map) => { 
 
                        const Toast = Swal.mixin({
                          toast: true,
                          position: "top-end",
                          showConfirmButton: false,
                          timer: 3000,
                          timerProgressBar: true,
                          didOpen: async (toast) => {},
                          willClose: async () => {
                            window.location.reload();
                          },
                        });

                        Toast.fire({
                          icon: "success",
                          title: "E-mail enviado com sucesso!",
                        });
                      });
                    }
                  } catch (error) {
                    const message =
                      error.message || "Ocorreu um erro inexperado";

                    setStatus({ success: false });
                    setErrors({ submit: message });
                    setSubmitting(false);
                  }
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  isSubmitting,
                  touched,
                  values,
                }) => (
                  <Form noValidate={true} onSubmit={handleSubmit}>
                    {errors.submit && (
                      <Alert mt={2} mb={1} severity="warning">
                        {errors.submit}
                      </Alert>
                    )}
                    <DialogContent>
                      <DialogContentText>
                        Digite o endereço de e-mail da conta Minha Fono que não
                        consegue acessar.
                      </DialogContentText>
                      <TextField
                        type="email"
                        name="emailRecovery"
                        value={values.emailRecovery || ""}
                        error={Boolean(
                          touched.emailRecovery && errors.emailRecovery
                        )}
                        helperText={
                          touched.emailRecovery && errors.emailRecovery
                        }
                        onBlur={handleBlur}
                        onChange={handleChange}
                        autoComplete="chrome-off"
                        autoFocus
                        margin="dense"
                        id="name"
                        label="E-mail"
                        fullWidth
                        variant="standard"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClose}>Cancelar</Button>
                      <Button type="submit" disabled={isSubmitting}>
                        Enviar
                      </Button>
                    </DialogActions>
                  </Form>
                )}
              </Formik>
            </Dialog>

            <div className={classes.linksRow}>
              <Link
                onClick={handleClickOpen}
                className={classes.textLink}
              >
                Esqueceu a senha?
              </Link>
              <Link
                href="/admin/dashboard/registro"
                className={classes.textLink}
              >
                Não possui conta? Quero assinar.
              </Link>
            </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
